import { ArrayEnumerable } from "./ArrayEnumerable.js";
export class Grouping extends ArrayEnumerable {
    key;
    constructor(key, startingItem) {
        super(1);
        this.key = key;
        this[0] = startingItem;
    }
}
